export enum IdDocumentType {
  PASSPORT = 'PASSPORT',
  ID_CARD = 'ID_CARD',
  DRIVER_LICENSE = 'DRIVER_LICENSE',
  RESIDENCE_PERMIT = 'RESIDENCE_PERMIT',
}

export enum DocumentType {
  PASSPORT = 'PASSPORT',
  UTILITY_BILL = 'UTILITY_BILL',
  NATIONAL_ID_CARD = 'NATIONAL_ID_CARD',
  SELFIE = 'SELFIE',
  REGISTRY_EXTRACT = 'REGISTRY_EXTRACT',
  SHAREHOLDER_EXTRACT = 'SHAREHOLDER_EXTRACT',
  FINANCIAL_STATEMENT = 'FINANCIAL_STATEMENT',
  SOURCE_OF_FUNDS = 'SOURCE_OF_FUNDS',
  OWNERSHIP_STRUCTURE = 'OWNERSHIP_STRUCTURE',
  POWER_OF_ATTORNEY = 'POWER_OF_ATTORNEY',
  LICENCE = 'LICENCE',
  ARTICLES_OF_ASSOCIATION = 'ARTICLES_OF_ASSOCIATION',
  PARTNERSHIP_AGREEMENT = 'PARTNERSHIP_AGREEMENT',
  CHARTER_BY_LAWS = 'CHARTER_BY_LAWS',
  CERTIFICATE_OF_INCORPORATION = 'CERTIFICATE_OF_INCORPORATION',
  MEMORANDUM_OF_ASSOCIATION = 'MEMORANDUM_OF_ASSOCIATION',
  ACT_OF_FORMATION = 'ACT_OF_FORMATION',
  BUSINESS_REGISTRATION_CERTIFICATE = 'BUSINESS_REGISTRATION_CERTIFICATE',
  PROOF_OF_ADDRESS = 'PROOF_OF_ADDRESS',
  PROOF_OF_BANK_ACCOUNT = 'PROOF_OF_BANK_ACCOUNT',
  INTERNAL_POLICIES_ML_TF = 'INTERNAL_POLICIES_ML_TF',
  INTERNAL_POLICIES_SANCTION_IMPLEMENTATION = 'INTERNAL_POLICIES_SANCTION_IMPLEMENTATION',
  PROOF_OF_DIRECTOR_APPOINTMENT = 'PROOF_OF_DIRECTOR_APPOINTMENT',
  RESIDENCE_PERMIT = 'RESIDENCE_PERMIT',
  OTHER = 'OTHER',
}
